import {
  appendQueryParamsToURL,
  extendPMHeaders,
  getCredentialsConfig,
  withDefaultParams,
} from '../helpers/requestHelper'
import { RSAA } from 'redux-api-middleware'
import { PM_API_RESOURCES, PM_API_URLS } from '../constants'
import { generateActionTypesForPMAPI } from '../helpers/reducerHelper'
import { createPaginatedAPIAction } from '../helpers/paginationHelper'

const DEFAULT_PARAMETERS = {
  ALL: {
    limit: 1000,
  },
}

const getUserGroups = createPaginatedAPIAction(params => {
  return {
    [RSAA]: {
      endpoint: appendQueryParamsToURL(PM_API_URLS.USER_GROUPS, params),
      credentials: getCredentialsConfig(),
      method: 'GET',
      types: generateActionTypesForPMAPI(PM_API_RESOURCES.USER_GROUPS),
      headers: extendPMHeaders(),
    },
  }
})

export const getAllUserGroups = withDefaultParams(getUserGroups, DEFAULT_PARAMETERS.ALL)
